// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3TXWk","detailsBorder":"styles_detailsBorder__1Nb3u"};